import React, { useEffect, useRef, useState } from "react";
import { FaEdit } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./OrderDetails.scss";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import { Modal } from "react-bootstrap";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import Swal from "sweetalert2";
import CustomTable from "../../../../customComponents/CustomTable";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { showErrorAlert } from "../../../../customComponents/CustomSweetAlert/errorsweetalert";
import "bootstrap/dist/css/bootstrap.min.css";

const OrderDetails = () => {
  const [poDetails, setPoDetails] = useState({});
  const [vehicleData, setVehicleData] = useState([]);
  const [accessoryData, setAccessoryData] = useState([]);
  const [sparePartData, setSparePartData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [variantOptions, setVariantOptions] = useState([]);
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [damagedQty, setDamagedQty] = useState(0); // New state to manage damaged quantity
  const location = useLocation();
  const data = location?.state?.data;
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [actionTaken, setActionTaken] = useState([]);

  const [currentViewedItem, setCurrentViewedItem] = useState(null); // Add this state

  const [loadingSerialData, setLoadingSerialData] = useState(false);

  const [modalImage, setModalImage] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [expectedDate, setExpectedDate] = useState("");

  const [itemTypeData, setItemTypeData] = useState("");

  const [totalAmtVal, setTotalAmtVal] = useState();

  const [tablepaymentStatus, setTablePaymentStatus] = useState([]);

  const [showSerialModal, setShowSerialModal] = useState(false);
  const [acceptModal, setAcceptModal] = useState(false);

  const [totalPriceVal, setTotalPriceVal] = useState();

  const [uploadModal, setUploadModal] = useState(false);

  const dealerId = localStorage.getItem("dealerId");

  const [remark, setRemark] = useState("");
  console.log("orderdetailsdata", data);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const is_on_created = localStorage.getItem("is_on_created");
  const is_partial_payment = localStorage.getItem("is_partial_payment");

  console.log(is_on_created, "isOnCredit");

  const datePickerRefs = useRef({}); // Reference for DatePicker

  const handleChange = (fieldName, date) => {
    // Format the date to "dd/MM/yyyy" and update state
    const formattedDate = date
      ? date.toLocaleDateString("en-GB").replace(/\//g, "/")
      : "";
    setExpectedDate(formattedDate);
  };

  const openDatePicker = (fieldName) => {
    // Open DatePicker when icon is clicked
    if (datePickerRefs.current[fieldName]) {
      datePickerRefs.current[fieldName].setFocus();
    }
  };

  useEffect(() => {
    if (data?.po_id) {
      fetchOrderDetails();
    }
  }, [data]);

  useEffect(() => {
    fetchVariantOptions();
  }, []);

  const fetchVariantOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const handleRejectOrder = async () => {
    try {
      const response = await axiosInstance.patch(
        `/purchaseorder/rejectpurchaseorder/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  const fetchOrderDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/edit/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data.data;

      // console.log(fetchedData?.podetaildata?.Vehicle[0]?.is_accepted, "vehicleDaata")
      console.log(fetchedData?.podetaildata?.total_Price, "totalPriceVal");
      setTotalPriceVal(fetchedData?.podetaildata?.total_Price);
      console.log();
      setPoDetails(fetchedData.Purchaseorderdetails[0]);
      setVehicleData(fetchedData.podetaildata["Vehicle"] || []);
      setAccessoryData(fetchedData.podetaildata["Accessories"] || []);
      setSparePartData(fetchedData.podetaildata["Spare-Parts"] || []);
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleDamageChange = (e) => {
    const value = e.target.value;
    setDamagedQty(Number(value)); // Set damaged quantity
  };

  // const DamagedInputs = () => {
  //   console.log("damagedquantity",damagedQty);

  //   const inputs = [];
  //   for (let i = 0; i < damagedQty; i++) {
  //     inputs.push(
  //       <div key={i} className="d-flex flex-wrap align-items-center mb-3">
  //         <div className="col-lg-6">
  //           <label>Vin No.</label>
  //           <select className="form-control">
  //             <option value="">Select...</option>
  //             {variantOptions.map((option) => (
  //               <option key={option.value} value={option.value}>
  //                 {option.label}
  //               </option>
  //             ))}
  //           </select>
  //         </div>
  //         <div className="col-lg-6">
  //           <label>Remark</label>
  //           <input type="text" className="form-control" placeholder="Enter Remark" />
  //         </div>
  //       </div>
  //     );
  //   }
  //   return inputs;
  // };
  const handledownload = async () => {
    try {
      const response = await axiosInstance.get(
        `/download-sample-posrnoupdate/${data.po_id}/${data?.accepted_qty}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          responseType: "blob", // Set response type to blob for file downloads
        },
      );

      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement("a");
      link.href = url;

      // Set the file name for the download to .csv
      link.setAttribute("download", "sample.csv"); // Changed to .csv

      // Append the link to the body (required for some browsers)
      document.body.appendChild(link);

      // Programmatically trigger the click event on the link
      link.click();

      // Clean up the link after download
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };
  // const UploadInputs = [
  //   {
  //     name: "payment_status",
  //     label: "Payment Status",
  //     type: "dropdown",
  //     required: true,
  //     placeholder: "Select Complaint",
  //     options: [
  //       { label: "Pending", value: "Pending" },
  //       { label: "Partially Payment", value: "Partially Payment" },
  //       ...(is_on_created === 1
  //         ? [{ label: "On Credit", value: "On Credit" }]
  //         : []),
  //       { label: "Full Payment", value: "Done" },
  //     ],
  //     gridClass: "col-lg-7",
  //   },
  //   ...( formData.payment_status === "On Credit"
  //     ?
  //     [
  //       {
  //         name: "payment_status_remark",
  //         label: "Remark",
  //         type: "text",
  //         // required: true,
  //         placeholder: "Enter Remark",
  //         gridClass: "col-lg-7",
  //       },
  //   ]: []
  //   ),
  //   {
  //     name: "payment_trans_image",
  //     label: "Bulk Upload ",
  //     type: "uploadFile",
  //     required: true,
  //     gridClass: "col-lg-6",
  //     //validation:{required:true}
  //   },
  // ];

  // useEffect(() => {
  //   if (formData.payment_status === "Done") {
  //     const effectiveAmount =
  //       totalAmtVal === null || totalAmtVal === undefined || totalAmtVal === 0
  //         ? totalPriceVal
  //         : totalAmtVal;

  //     setFormData((prev) => ({
  //       ...prev,
  //       paid_amount: effectiveAmount,
  //     }));
  //   }
  // }, [formData.payment_status, totalAmtVal, totalPriceVal]);

  useEffect(() => {
    if (
      formData.payment_status === "Full Payment" ||
      "Partially Payment" ||
      "On Credit" ||
      "Advance Payment"
    ) {
      if (totalAmtVal === 0) {
        setFormData((prev) => ({
          ...prev,
          paid_amount: "0.00",
        }));
      } else if (totalAmtVal != null) {
        setFormData((prev) => ({
          ...prev,
          paid_amount: totalAmtVal,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          paid_amount: totalPriceVal,
        }));
      }
    }
  }, [formData.payment_status, totalAmtVal, totalPriceVal]);

  // useEffect(() => {
  //   if (formData.payment_status === "Done") {
  //     setFormData(prev => ({
  //       ...prev,
  //       paid_amount: totalPriceVal
  //     }));
  //   }
  // }, [formData.payment_status]);

  const UploadInputs = [];

  // Payment status dropdown
  const paymentStatusOptions = [
    { label: "Advance Payment", value: "Advance Payment" },
  ];

  if (is_partial_payment == 1) {
    paymentStatusOptions.push({
      label: "Partially Credit",
      value: "Partially Credit",
    });
  }

  if (is_on_created == 1) {
    paymentStatusOptions.push({ label: "On Credit", value: "On Credit" });
  }

  paymentStatusOptions.push({ label: "Full Payment", value: "Full Payment" });

  UploadInputs.push({
    name: "payment_status",
    label: "Payment Status",
    type: "dropdown",
    required: true,
    placeholder: "Select Complaint",
    options: paymentStatusOptions,
    gridClass: "col-lg-7",
    validation: {
      required: true,
    },
  });

  const effectiveTotalAmount =
    totalAmtVal !== null && totalAmtVal !== "" ? totalAmtVal : totalPriceVal;
  UploadInputs.push({
    name: "paid_amount",
    label: "Amount",
    type: "number",
    required: true,
    placeholder: "Enter Amount",
    // maxLength: totalPriceVal,
    gridClass: "col-lg-7",
    disabled: formData.payment_status === "Full Payment",
    validation: {
      required: true,
      pattern: /^[1-9][0-9]*$/,
      message: "Please enter a positive number with no leading zeros",
      maxAmount: effectiveTotalAmount, // Make sure totalPriceVal is available here
    },
  });

  // Conditionally add Remark field if "On Credit" is selected
  if (formData.payment_status === "On Credit") {
    UploadInputs.push({
      name: "payment_status_remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      gridClass: "col-lg-7",
    });
  }

  // File upload field
  UploadInputs.push({
    name: "payment_image",
    label: "Payment Upload",
    type: "uploadFilepaymentStatus",
    required: true,
    gridClass: "col-lg-6",
  });

  const paymentType = formData.payment_status;
  const paidAmount = parseFloat(formData.paid_amount);
  const effectiveTotal = totalAmtVal || totalPriceVal;

  const disableSubmit =
    totalAmtVal === 0 || // Disable if totalAmtVal is 0
    (["Advance Payment", "Partially Credit", "On Credit"].includes(
      paymentType,
    ) &&
      paidAmount > effectiveTotal);

  const DamagedInputs = () => {
    console.log("damagedquantity", damagedQty);

    if (damagedQty > 10) {
      return (
        <div className="mb-3">
          <div className="col-lg-12">
            <div className="downloadiconwrapperr" onClick={handledownload}>
              <a className="downloadHeading">Download File Sample</a>
              <img src={downloadIcon} alt="download" className="downloadImg" />
            </div>
            <DynamicForm
              formConfig={UploadInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              totalPriceVal={totalPriceVal}
            />
          </div>
        </div>
      );
    }

    const inputs = [];
    for (let i = 0; i < damagedQty; i++) {
      inputs.push(
        <div key={i} className="d-flex flex-wrap align-items-center mb-3">
          <div className="col-lg-6">
            <label>Vin No.</label>
            <select className="form-control">
              <option value="">Select...</option>
              {variantOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-lg-6">
            <label>Remark</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Remark"
            />
          </div>
        </div>,
      );
    }

    return inputs;
  };

  const handleFormSubmit = async (formData) => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("importFileUpload", formData.uploadDocument);

      console.log(formData, "uploadedDocument");

      const response = await axiosInstance.post(
        "/bulkupload/importBulk",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const { errors, success } = response.data.data;

      // Update state with success and failed records
      // setSuccessRows(success);
      // setFailedRows(errors);

      // Success Alert
      Swal.fire({
        title: "File Uploaded",
        text: `File uploaded successfully with ${success.length} successful rows and ${errors.length} failed rows.`,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      // Error Alert
      Swal.fire({
        title: "Error",
        text: "Failed to upload file. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  // const DamagedInputs = ({ damagedQty, variantOptions }) => {
  //   const inputs = [];

  //   // Render individual input fields if damagedQty is 10 or less
  //   if (damagedQty <= 10) {
  //     for (let i = 0; i < damagedQty; i++) {
  //       inputs.push(
  //         <div key={i} className="d-flex flex-wrap align-items-center mb-3">
  //           <div className="col-lg-6">
  //             <label>Vin No.</label>
  //             <select className="form-control">
  //               <option value="">Select...</option>
  //               {variantOptions.map((option) => (
  //                 <option key={option.value} value={option.value}>
  //                   {option.label}
  //                 </option>
  //               ))}
  //             </select>
  //           </div>
  //           <div className="col-lg-6">
  //             <label>Remark</label>
  //             <input type="text" className="form-control" placeholder="Enter Remark" />
  //           </div>
  //         </div>
  //       );
  //     }
  //   } else {
  //     // Show bulk upload options if damagedQty is greater than 10
  //     inputs.push(
  //       <div key="bulk-upload" className="mb-4">
  //         <button
  //           className="btn btn-primary me-3"
  //           onClick={handleDownloadCSV}
  //         >
  //           Download CSV Template
  //         </button>
  //         <input type="file" className="form-control" onChange={handleFileUpload} />
  //       </div>
  //     );
  //   }

  //   return <>{inputs}</>;
  // };

  const handleDownloadCSV = () => {
    const headers = ["Vin No.", "Remark"];
    const csvContent = `data:text/csv;charset=utf-8,${headers.join(",")}\n`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.href = encodedUri;
    link.download = "bulk_upload_template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const csvData = event.target.result;
        console.log("Uploaded CSV Data:", csvData);
        // Process CSV data here (you may need to parse it)
      };
      reader.readAsText(file);
    }
  };
  const toggleEdit = (item, setData) => {
    setData((prevData) =>
      prevData.map((d) =>
        d.po_details_id === item.po_details_id
          ? { ...d, editable: !d.editable }
          : d,
      ),
    );
  };

  const handleRequestForReturn = (item) => {
    setShowModal(true);
  };

  const itemLabels = {
    Vehicle: [
      { label: "PO Number", key: "podetail_number" },
      //{ label: 'Name', key: 'name' },
      { label: "Type", key: "itemtypename" },
      { label: "Color", key: "color_name" },
      //{ label: 'Make', key: 'make_name' },
      { label: "Model", key: "model_name" },
      { label: "Variant Name", key: "variant_name" },
      { label: "Order Quantity", key: "quantity" },
      { label: "Approved Quantity", key: "accepted_qty" },
      { label: "Accepted by dealer", key: "quantity_approval_dealer" },
      // { label: 'Rejected', key: 'rejectqty' },

      { label: "Rate (₹)", key: "rate" },
      { label: "Tax (%)", key: "tax" },
      { label: "Tax Amount (₹)", key: "taxset_amount" },
      { label: "Price (₹)", key: "totalprice" },
      { label: "Job Card Number", key: "job_card_number" },
      { label: "Variant Remark", key: "variant_remark" },
      { label: "Expected Date", key: "po_expected_date" },
      { label: "Remark", key: "rejected_remark" },

      // podetail_number
      // rejected_remark
      // variant_remark
    ],
    Accessories: [
      { label: "PO Number", key: "podetail_number" },
      { label: "Name", key: "name" },
      { label: "Type", key: "itemtypename" },
      { label: "Color", key: "color_name" },
      { label: "Model", key: "model_name" },
      // { label: "Category Name", key: "part_category_name" },
      { label: "Order Quantity", key: "quantity" },
      // { label: 'Color Name', key: 'color_name' },
      { label: "Approved Quantity", key: "accepted_qty" },
      { label: "Accepted by dealer", key: "quantity_approval_dealer" },
      // { label: 'Rejected', key: 'rejectqty' },
      { label: "Rate (₹)", key: "rate" },
      { label: "Tax (%)", key: "tax" },
      { label: "Tax Amount (₹)", key: "taxset_amount" },
      { label: "Price (₹)", key: "totalprice" },
      { label: "Job Card Number", key: "job_card_number" },
      { label: "Expected Date", key: "po_expected_date" },
      { label: "Remark", key: "rejected_remark" },
    ],
    "Spare-Parts": [
      { label: "PO Number", key: "podetail_number" },
      { label: "Name", key: "name" },
      { label: "Part Number", key: "part_number" },
      { label: "Type", key: "itemtypename" },
      // { label: "Category Name", key: "part_category_name" },
      { label: "Color Name", key: "color_name" },
      { label: "Model", key: "model_name" },
      { label: "Order Quantity", key: "quantity" },
      { label: "Approved Quantity", key: "accepted_qty" },
      { label: "Accepted by dealer", key: "quantity_approval_dealer" },
      // { label: 'Rejected', key: 'rejectqty' },
      { label: "Job Card Number", key: "job_card_number" },
      { label: "Rate (₹)", key: "rate" },
      { label: "Tax (%)", key: "tax" },
      { label: "Tax Amount (₹)", key: "taxset_amount" },
      { label: "Price (₹)", key: "totalprice" },
      { label: "Expected Date", key: "po_expected_date" },
      { label: "Remark", key: "rejected_remark" },
    ],
  };

  //   const keyMapping =
  //  {
  //     'Chassis No': 'chassis_no',
  //     'VIN No': 'vin_no',
  //     'Serial No': 'serial_no'
  //  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (currentViewedItem) {
      handleViewDetails(currentViewedItem, newPage);
    }
  };

  const Job_Card_TABLE_HEADERS = [
    // "Date",
    "PO Number",
    "Total Amount",
    "Paid Amount",
    "Pending Amount",
    "Payment Status",
    "Payment Image",
    "Payment Date Time",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "PO Number": "po_number",
    "Total Amount": "total_amount",
    "Paid Amount": "paid_amount",
    "Pending Amount": "pending_amount",
    "Payment Status": "payment_status",
    "Payment Image": "payment_image",
    "Payment Date Time": "payment_date",
  };

  const TABLE_HEADERS =
    itemTypeData === "V"
      ? [
          "Variant",
          "Color",
          "VIN No",
          "Status",
          "Dealer Remark",
          "Admin Remark",
          "Dealer Acknowledgement Remark",
        ]
      : [
          "Item Name",
          "Serial No",
          "Status",
          "Dealer Remark",
          "Admin Remark",
          "Dealer Acknowledgement Remark",
        ];

  const keyMapping =
    itemTypeData === "V"
      ? {
          "Chassis No": "chassis_no",
          "VIN No": "vin_no",
          Color: "color_name",
          Variant: "variant_name",
          Status: "dealer_approved_status_text",
          "Dealer Remark": "dealer_approval_remark",
          "Admin Remark": "admin_damaged_missing_remark",
          "Dealer Acknowledgement Remark": "dealer_final_acknowledge_remark",
        }
      : {
          "Item Name": "item_name",
          "Serial No": "serial_no",
          Status: "dealer_approved_status_text",
          "Dealer Remark": "dealer_approval_remark",
          "Admin Remark": "admin_damaged_missing_remark",
          "Dealer Acknowledgement Remark": "dealer_final_acknowledge_remark",
        };

  //  const TABLE_HEADERS = ['Chassis No', 'VIN No', 'Serial No']

  // const TABLE_HEADERS = selectedItemType === 'Vehicle'
  // ? ['Chassis No', 'VIN No', 'Engine No']
  // : ['Serial No'];

  const handleApprovalAPI = async (remark) => {
    try {
      const payload = {
        remark,
      };

      const response = await axiosInstance.patch(
        `/purchaseorder/rejectpurchaseorder/${data?.po_id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response?.status == 200) {
        navigate(ROUTES_NAVIGATION.MANAGEORDERLIST);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const handleViewDetails = async (item, page = 0, pageSize = 10) => {
    setShowSerialModal(true);
    setCurrentViewedItem(item);
    // Handle viewing details of the item here
    console.log("View details for item:", item);
    try {
      // setLoading(true)
      const response = await axiosInstance.post(
        `podetails/getseriallistpoidwise`,
        {
          orderBy: "postockinsr_id desc",
          page,
          pageSize,
          endDate: null,
          startDate: null,
          po_details_id: item.po_details_id,
          searchText: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        chassis_no: item.chassis_no || "--",
        vin_no: item.vin_no || "--",
        chassis_no: item.chassis_no || "--",
        dealer_approval_remark: item?.dealer_approval_remark || "--",
        admin_damaged_missing_remark: item?.admin_damaged_missing_remark || "--",
        dealer_final_acknowledge_remark: item?.dealer_final_acknowledge_remark || "--"
      }));

      const fetchedData = response?.data?.data?.data[0]?.itemtype;
      setItemTypeData(fetchedData);
      console.log(fetchedData, "fetchedDataHandleView");

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      setTotalRecords(totalRecordsData);

      setActionTaken(formattedData);
      console.log(response, "serialdata");
      setTotalPages(Math.ceil(totalRecordsData / pageSize));
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    } finally {
      // setLoading(false)
    }
  };

  // const renderItemRow = (item, setData, data, type) => {
  //   const labels = itemLabels[type] || [];

  //   console.log(vehicleData, "vehicleDAta")

  //   return (
  //     <div className="d-flex flex-wrap align-items-start p-3 mb-3 gap-5" key={item.po_details_id}>
  //       {/* Display item labels */}
  //       {labels.map(
  //         (field, index) =>
  //           item[field.key] !== undefined &&
  //           item[field.key] !== null && (
  //             <div className="d-flex flex-column me-4 gap-2" key={index}>
  //               <h6 className="text-muted">{field.label}</h6>
  //               <span>{item[field.key] !== '' ? item[field.key] : 'N/A'}</span>
  //             </div>
  //           )
  //       )}

  //       {/* Conditional Rendering for isaccepted Status */}
  //       <div className="ms-auto d-flex align-items-center">
  //         {item.is_accepted === 1 && item.delivered_qty > 0 && (
  //           <button
  //             className="btn btn-outline-success"
  //             onClick={() => handleViewDetails(item)}
  //           >
  //             View
  //           </button>
  //         )}
  //         {item.is_accepted === 2 && (
  //           <span className="text-danger fw-bold ms-2">Rejected</span>
  //         )}
  //       </div>

  //       {/* Request for Return Button */}
  //       {item?.defective_qty>0 && <button
  //         className="btn btn-outline-success ms-3"
  //         onClick={() => handleRequestForReturn(item)}
  //       >
  //         Request Return
  //       </button> }

  //     </div>
  //   );
  // };

  //   const renderItemRow = (item, setData, data, type) => {
  //     const labels = itemLabels[type] || [];

  //     return (
  //       <div className="d-flex flex-wrap align-items-start p-3 mb-3 gap-4" key={item.po_details_id}>
  //         {labels.map(
  //           (field, index) =>
  //             item[field.key] !== undefined &&
  //             item[field.key] !== null && (
  //               <div className="d-flex flex-column me-4 gap-2" key={index}>
  //                 <h6 className="text-muted">{field.label}</h6>
  //                 <span>{item[field.key] !== '' ? item[field.key] : 'N/A'}</span>
  //               </div>
  //             )
  //         )}

  //         {/* Damaged Quantity Section */}
  //         <div className="d-flex flex-column me-4">
  //           <small className="text-muted">Damaged Quantity</small>
  //           <div className="d-flex align-items-center">
  //             {item.editable ? (
  //               <>
  //                 <input
  //                   type="number"
  //                   value={item.defective_qty}
  //                   onChange={(e) =>
  //                     setData((prevData) =>
  //                       prevData.map((d) =>
  //                         d.po_details_id === item.po_details_id
  //                           ? { ...d, damaged_qty: e.target.value }
  //                           : d
  //                       )
  //                     )
  //                   }
  //                   className="form-control"
  //                   style={{ width: '40px',height:'40px' }}
  //                   min="0"
  //                 />
  //                 <button
  //                   className="btn btn-success ms-2"
  //                   onClick={() => handleSave(item, setData)}
  //                 >
  //                   Save
  //                 </button>
  //               </>
  //             ) : (
  //               <>
  //                 <span>{item.damaged_qty ?? 0}</span>
  //                 <FaEdit
  //                   className="text-primary ms-2"
  //                   style={{ cursor: 'pointer' }}
  //                   onClick={() => toggleEdit(item, setData)}
  //                 />
  //               </>
  //             )}
  //           </div>
  //         </div>

  //         {/* Request for Return Button */}
  //         <button
  //           className="btn btn-outline-success ms-auto"
  //           onClick={() => handleRequestForReturn(item)}
  //         >
  //           Request Return
  //         </button>
  //       </div>
  //     );
  //   };

  // const renderTable = (data, setData, type) => {
  //   const labels = itemLabels[type] || [];

  //   // Table styles
  //   const tableStyle = {
  //       width: '100%',
  //       borderCollapse: 'collapse',
  //       marginTop: '20px',
  //   };

  //   const headerStyle = {
  //       fontSize: '14px',
  //       fontWeight: 'bold',
  //       borderBottom: '1px solid lightgray',
  //       padding: '10px',
  //       textAlign: 'left',
  //   };

  //   const cellStyle = {
  //       padding: '10px',
  //       borderBottom: '1px solid lightgray',
  //       textAlign: 'left',
  //   };

  //   const actionCellStyle = {
  //       ...cellStyle,
  //       textAlign: 'center',
  //   };

  //   return (
  //       <table style={tableStyle}>
  //           <thead>
  //               <tr>
  //                   {labels.map((label, index) => (
  //                       <th key={index} style={headerStyle}>
  //                           {label.label}
  //                       </th>
  //                   ))}
  //                   <th style={headerStyle}>Action</th>
  //               </tr>
  //           </thead>
  //           <tbody>
  //               {data.map((item) => (
  //                   <tr key={item.po_details_id}>
  //                       {labels.map((field, index) => (
  //                           <td key={index} style={cellStyle}>
  //                               {field.key === 'accepted_qty' ? (
  //                                   item.editable ? (
  //                                       <input
  //                                           type="number"
  //                                           value={item.accepted_qty}
  //                                           onChange={(e) =>
  //                                               setData((prev) =>
  //                                                   prev.map((d) =>
  //                                                       d.po_details_id === item.po_details_id
  //                                                           ? { ...d, accepted_qty: e.target.value }
  //                                                           : d
  //                                                   )
  //                                               )
  //                                           }
  //                                           style={{
  //                                               width: '60px',
  //                                               height: '30px',
  //                                           }}
  //                                       />
  //                                   ) : (
  //                                       <span>{item.accepted_qty || 0}</span>
  //                                   )
  //                               ) : item[field.key] !== undefined &&
  //                                 item[field.key] !== null ? (
  //                                   item[field.key]
  //                               ) : (
  //                                   'N/A'
  //                               )}
  //                           </td>
  //                       ))}
  //                       <td style={actionCellStyle}>
  //                           {item.is_accepted === 1 && item.delivered_qty > 0 ? (
  //                               <button
  //                                   className="btn btn-outline-success"
  //                                   onClick={() => handleViewDetails(item)}
  //                               >
  //                                   View
  //                               </button>
  //                           ) : null}
  //                           {item.is_accepted === 2 ? (
  //                               <span className="text-danger">Rejected</span>
  //                           ) : null}
  //                           {item.defective_qty > 0 ? (
  //                               <button
  //                                   className="btn btn-outline-success
  //                                   onClick={() => handleRequestForReturn(item)}
  //                               >
  //                                   Request Return
  //                               </button>
  //                           ) : null}
  //                           {/* <span
  //                           style={{
  //                               color: 'gray',
  //                               fontStyle: 'italic',
  //                               fontSize:"14px"
  //                           }}
  //                       >
  //                           No actions to perform
  //                       </span> */}
  //                       </td>
  //                   </tr>
  //               ))}
  //           </tbody>
  //       </table>
  //   );
  // };

  // const renderTable = (data, setData, type, postatus) => {
  //   const labels = itemLabels[type] || [];

  //   // Table styles
  //   const tableStyle = {
  //     width: '100%',
  //     borderCollapse: 'collapse',
  //     marginTop: '20px',
  //     border: '1px solid black',
  //   };

  //   const headerStyle = {
  //     fontSize: '14px',
  //     fontWeight: 'bold',
  //     border: '1px solid black',
  //     padding: '10px',
  //     textAlign: 'left',
  //     backgroundColor: '#f2f2f2',
  //   };

  //   const cellStyle = {
  //     padding: '10px',
  //     border: '1px solid black',
  //     textAlign: 'left',
  //   };

  //   const actionCellStyle = {
  //     ...cellStyle,
  //     textAlign: 'center',
  //   };

  //   return (
  //     <table style={tableStyle}>
  //       <thead>
  //         <tr>
  //           {labels.map((label, index) => (
  //             <th key={index} style={headerStyle}>
  //               {label.label}
  //             </th>
  //           ))}
  //           {/* Conditionally render the Action column */}
  //           {postatus !== 'Pending' && (
  //             <th style={headerStyle}>Action</th>
  //           )}
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {data.map((item) => (
  //           <tr key={item.po_details_id}>
  //             {labels.map((field, index) => (
  //               <td key={index} style={cellStyle}>
  //                 {field.key === 'accepted_qty' ? (
  //                   item.editable ? (
  //                     <input
  //                       type="number"
  //                       value={item.accepted_qty}
  //                       onChange={(e) =>
  //                         setData((prev) =>
  //                           prev.map((d) =>
  //                             d.po_details_id === item.po_details_id
  //                               ? { ...d, accepted_qty: e.target.value }
  //                               : d
  //                           )
  //                         )
  //                       }
  //                       style={{
  //                         width: '60px',
  //                         height: '30px',
  //                       }}
  //                     />
  //                   ) : (
  //                     <span>{item.accepted_qty || 0}</span>
  //                   )
  //                 ) : item[field.key] !== undefined &&
  //                   item[field.key] !== null ? (
  //                   item[field.key]
  //                 ) : (
  //                   '--'
  //                 )}
  //               </td>
  //             ))}
  //             {/* Conditionally render Action cells */}
  //             {postatus !== 'Pending' && (
  //               <td style={actionCellStyle}>
  //                 {item.is_accepted === 1 && item.delivered_qty > 0 ? (
  //                   <button
  //                     className="btn btn-outline-success"
  //                     onClick={() => handleViewDetails(item)}
  //                   >
  //                     View
  //                   </button>
  //                 ) : null}
  //                 {item.is_accepted === 2 ? (
  //                   <span className="text-danger">Rejected</span>
  //                 ) : null}
  //                 {item.defective_qty > 0 ? (
  //                   <button
  //                     className="btn btn-outline-success
  //                     onClick={() => handleRequestForReturn(item)}
  //                   >
  //                     Request Return
  //                   </button>
  //                 ) : null}
  //               </td>
  //             )}
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>
  //   );
  // };

  const renderTable = (data, setData, type, postatus) => {
    const labels = itemLabels[type] || [];

    const tableContainerStyle = {
      width: "100%",
      overflowX: "auto",
      maxWidth: "100%",
    };

    const tableStyle = {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
      border: "1px solid black",
      minWidth: "600px", // Ensures the table is wider than small screens
    };

    const headerStyle = {
      fontSize: "14px",
      fontWeight: "bold",
      border: "1px solid black",
      padding: "10px",
      textAlign: "left",
      backgroundColor: "#f2f2f2",
    };

    const cellStyle = {
      padding: "10px",
      border: "1px solid black",
      textAlign: "left",
    };

    const actionCellStyle = {
      ...cellStyle,
      textAlign: "center",
    };

    return (
      <div style={tableContainerStyle}>
        <table style={tableStyle}>
          <thead>
            <tr>
              {labels.map((label, index) => (
                <th key={index} style={headerStyle}>
                  {label.label}
                </th>
              ))}
              {postatus !== "Pending" && <th style={headerStyle}>Action</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.po_details_id}>
                {labels.map((field, index) => (
                  <td key={index} style={cellStyle}>
                    {/* {field.key === "accepted_qty" ? (
                      item.editable ? (
                        <input
                          type="number"
                          value={item.accepted_qty}
                          onChange={(e) =>
                            setData((prev) =>
                              prev.map((d) =>
                                d.po_details_id === item.po_details_id
                                  ? { ...d, accepted_qty: e.target.value }
                                  : d
                              )
                            )
                          }
                          style={{
                            width: "60px",
                            height: "30px",
                          }}
                        />
                      ) : (
                        <span>{item.accepted_qty || 0}</span>
                      )
                    ) : item[field.key] !== undefined &&
                      item[field.key] !== null ? (
                      item[field.key]
                    ) : (
                      "--"
                    )} */}
                    {field.key === "accepted_qty" ? (
                      item.is_accepted === 2 ? (
                        <span>0</span>
                      ) : item.editable ? (
                        <input
                          type="number"
                          value={item.accepted_qty}
                          onChange={(e) =>
                            setData((prev) =>
                              prev.map((d) =>
                                d.po_details_id === item.po_details_id
                                  ? { ...d, accepted_qty: e.target.value }
                                  : d,
                              ),
                            )
                          }
                          style={{
                            width: "60px",
                            height: "30px",
                          }}
                        />
                      ) : (
                        <span>{item.accepted_qty || 0}</span>
                      )
                    ) : item[field.key] !== undefined &&
                      item[field.key] !== null ? (
                      item[field.key]
                    ) : (
                      "--"
                    )}
                  </td>
                ))}
                {postatus !== "Pending" && (
                  <td style={actionCellStyle}>
                    {item.is_accepted === 1 && item.delivered_qty > 0 ? (
                      <button
                        className="btn btn-outline-success"
                        onClick={() => handleViewDetails(item)}
                      >
                        View
                      </button>
                    ) : null}
                    {item.is_accepted === 2 ? (
                      <span className="text-danger">Rejected</span>
                    ) : null}
                    {/* {item.defective_qty > 0 ? (
                      <button
                        className="btn btn-outline-success"
                        onClick={() => handleRequestForReturn(item)}
                      >
                        Request Return
                      </button>
                    ) : null} */}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const handleRejectModalClose = () => {
    setShowRejectModal(false);
  };

  const fieldLabels = {
    po_number: "PO No.",
    po_date: "PO Date",
    po_expected_date: "Dealer Expected Date",
    estimated_delivery_date: "Revised Expected Date",
    dealer_name: "Dealer Name",
    dealer_pin_code: "PinCode",
    dealer_address: "Address",
    postatus: "Status",
    total: "Total Price",
    approval_remark: "Remark",
    payment_status: "Payment Status",
    // payment_trans_image: "Transaction Image",
    payment_status_remark: "Payment Status Remark",
    // Add more fields here as needed...
  };
  const handleSave = async (item, setData) => {
    const damagedQuantity = Number(item?.damaged_qty);
    console.log("damagedquantity", damagedQuantity);

    try {
      // API call to save the damaged quantity
      await axiosInstance.patch(
        `/podetails/updatedamagePodetails/${item?.po_details_id}`,
        {
          defective_qty: damagedQuantity,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      // Toggle edit mode off after saving
      setData((prevData) =>
        prevData.map((d) =>
          d.po_details_id === item.po_details_id
            ? { ...d, editable: false }
            : d,
        ),
      );
    } catch (error) {
      console.error("Error updating damaged quantity:", error);
    }
  };

  const includedFields = [
    "po_number",
    "po_date",
    "po_expected_date",
    "estimated_delivery_date",
    "dealer_name",
    "dealer_pin_code",
    "dealer_address",
    "total",
    "approval_remark",
    "postatus",
    "rejected_remark",
    "payment_status",
    "variant_remark",
    // "payment_trans_image",
    "payment_status_remark",
  ];

  const handleAcceptModalOpen = () => {
    setAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setAcceptModal(false);
  };

  const uploadOpenModal = () => {
    setUploadModal(true);
  };

  const closeUploadodal = () => {
    setUploadModal(false);
  };

  // const handleSubmit = async (formData) => {
  //   console.log("clicked");

  //   // Create a FormData object
  //   const formDataPayload = new FormData();

  //   formDataPayload.append("payment_status", formData.payment_status);
  //   formDataPayload.append("paid_amount", formData.paid_amount);
  //   formDataPayload.append(
  //     "payment_status_remark",
  //     formData.payment_status_remark ? formData.payment_status_remark : null
  //   );

  //   // Append the image file if it exists
  //   if (formData.payment_trans_image instanceof File) {
  //     formDataPayload.append(
  //       "payment_trans_image",
  //       formData.payment_trans_image
  //     );
  //   }

  //   const result = await Swal.fire({
  //     title: "Confirmation",
  //     text: "Are you sure you update the payment status?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     showLoaderOnConfirm: true,
  //     preConfirm: async () => {
  //       try {
  //         const response = await axiosInstance.patch(
  //           `/podetails/paymentStatus/${data.po_id}`,
  //           formDataPayload, // Send FormData instead of JSON
  //           {
  //             headers: {
  //               "Content-Type": "multipart/form-data",
  //               Authorization: `Bearer ${authToken}`,
  //             },
  //           }
  //         );

  //         console.log(response, "response");
  //         if (response.status === 200) {
  //           fetchOrderDetails();
  //           closeAcceptModal();
  //           setFormData({})
  //         }
  //       } catch (error) {
  //         console.log(error, "errorresponse");

  //         const errorMessage = error.response?.data?.data;
  //         console.log(errorMessage, "errorMessage");

  //         showErrorAlert({
  //           title: "Warning",
  //           text: errorMessage || "Something went wrong",
  //           callback: () => {
  //             console.log("Error alert confirmed");
  //           },
  //         });
  //       }
  //     },
  //   });

  //   if (!result.isConfirmed) {
  //     // setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchPaymentValues();
  }, []);

  const fetchPaymentValues = async () => {
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/po-paymnent-history/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response?.data?.data?.data;
      console.log(fetchedData, "fetchedData");
      setTablePaymentStatus(fetchedData);
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  useEffect(() => {
    fetchTotalPriceValue();
  }, [acceptModal]);

  const fetchTotalPriceValue = async () => {
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/get-popyment/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response?.data?.data?.pending_amount;
      console.log(fetchedData, "fetchedData");
      setTotalAmtVal(fetchedData);
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  const handleSubmit = async (formData) => {
    console.log("clicked");

    const errors = {};
    let isValid = true;

    UploadInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const effectiveTotalAmount =
      totalAmtVal !== null && totalAmtVal !== "" ? totalAmtVal : totalPriceVal;

    const paidAmount = parseFloat(formData.paid_amount);
    const isPartialOrCredit =
      formData.payment_status === "Partially Credit" ||
      formData.payment_status === "On Credit" ||
      formData.payment_status === "Full Payment";

    if (isPartialOrCredit && paidAmount < effectiveTotalAmount) {
      const confirmPartial = await Swal.fire({
        title: "Confirm Partial Payment",
        html: `The total amount is <strong>${effectiveTotalAmount}</strong> but you're paying <strong>${paidAmount}</strong>.<br><br>Are you sure you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Continue",
        cancelButtonText: "No",
      });

      if (!confirmPartial.isConfirmed) {
        return; // Stop submission
      }
    }

    const allPoDetailsIds = [
      ...vehicleData.map((item) => item.po_details_id),
      ...accessoryData.map((item) => item.po_details_id),
      ...sparePartData.map((item) => item.po_details_id),
    ].filter(Boolean); // Remove null or undefined values if any

    const poDetailsIdString = allPoDetailsIds.join(",");
    // const effectiveTotalAmount = totalAmtVal !== null && totalAmtVal !== '' ? totalAmtVal : totalPriceVal;

    // Create a FormData object
    const formDataPayload = new FormData();

    formDataPayload.append("payment_status", formData.payment_status);
    // formDataPayload.append("paid_amount", formData.paid_amount);
    // formDataPayload.append("total_amount", totalPriceVal);
    // formDataPayload.append("total_amount", effectiveTotalAmount);
    formDataPayload.append("total_amount", effectiveTotalAmount.toString());
    formDataPayload.append("paid_amount", formData.paid_amount.toString());
    formDataPayload.append("dealer_id", dealerId);
    formDataPayload.append("po_id", data.po_id);
    // formDataPayload.append("po_details_id", data.po_id);
    formDataPayload.append("po_details_id", poDetailsIdString);
    formDataPayload.append(
      "remark",
      formData.payment_status_remark ? formData.payment_status_remark : "--",
    );

    if (formData.payment_image instanceof File) {
      formDataPayload.append("payment_image", formData.payment_image);
    }

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update the payment status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await axiosInstance.post(
            // `/podetails/paymentStatus/${data.po_id}`,
            `/purchaseorder/create-po-payment`,
            formDataPayload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          if (response.status === 200) {
            fetchOrderDetails();
            fetchPaymentValues();
            closeAcceptModal();
            setFormData({});
          }
        } catch (error) {
          const errorMessage = error.response?.data?.data;
          showErrorAlert({
            title: "Warning",
            text: errorMessage || "Something went wrong",
            callback: () => {
              console.log("Error alert confirmed");
            },
          });
        }
      },
    });

    if (!result.isConfirmed) {
      // Optional: Do something if the main confirmation is cancelled
    }
  };

  return (
    <div>
      <div
        style={{ paddingTop: "20px", borderBottom: "1px solid lightgray" }}
        className="header-container"
      >
        <div className="backbutton mt-2 mb-2">
          <img onClick={() => navigate(-1)} src={backicon} alt="back" />
          <span className="backbtntitle">Purchase Order Details</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <div>
            {/* postatus */}

            {/* <button
                onClick={handleAcceptModalOpen}
                style={{ paddingLeft: "45px", paddingRight: "45px" }}
                className="submit-btn order-management-details"
              >
                Upload Attachment
              </button> */}
          </div>

          <div>
            {/* postatus */}
            {/* {(poDetails?.payment_status === null ||
              poDetails?.payment_status === "Advance Payment" ||
              poDetails?.payment_status === "Partially Credit" || 
              // On Credit
              poDetails?.payment_status === "On Credit"
            ) &&
            (poDetails.is_order_accepted === 1 ||
              poDetails?.is_order_accepted === 3) ? (
              <button
                onClick={handleAcceptModalOpen}
                style={{ paddingLeft: "45px", paddingRight: "45px" }}
                className="submit-btn order-management-details"
              >
                Payment Status
              </button>
            ) : null} */}
            {/* {(poDetails?.oem_payment_status === 0 ||
              poDetails?.oem_payment_status === null) &&
              ( poDetails.payment_status !== "Full Payment") &&
            poDetails?.postatus !== "Drafted" &&
            poDetails?.postatus !== "Rejected" ? (
              <button
                onClick={handleAcceptModalOpen}
                style={{ paddingLeft: "45px", paddingRight: "45px" }}
                className="submit-btn order-management-details"
              >
                Payment Status
              </button>
            ) : null} */}
            {/* <button
                onClick={handleAcceptModalOpen}
                style={{ paddingLeft: "45px", paddingRight: "45px" }}
                className="submit-btn order-management-details"
              >
                Payment Status
              </button> */}
          </div>
          {/* <button
            onClick={() => navigate(-1)}
            style={{ paddingLeft: "45px", paddingRight: "45px" }}
            className="submit-btn order-management-details"
          >
            Back
          </button> */}
        </div>
      </div>

      {acceptModal && (
        <div className="customModalOverlay">
          <div className="custom-modal-expectedDate">
            <div className="custom-modal-header">
              <h6 style={{ fontSize: "18px" }}>Payment Status</h6>
              <button className="close-button" onClick={closeAcceptModal}>
                ×
              </button>
            </div>
            <div
              style={{ height: "24rem", overflow: "auto" }}
              className="custom-modal-body"
            >
              <DynamicForm
                formConfig={UploadInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              {/* <label htmlFor="expectedDate" style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                          Payment Status
                        </label> */}
              {/* <input
                          type="date"
                          id="expectedDate"
                          value={expectedDate} // Replace `remark` with a new `expectedDate` state
                          onChange={(e) => setExpectedDate(e.target.value)} // Ensure to create `setExpectedDate` for state management
                          // className="remark-textarea" 
                          style={{padding:"14px", borderRadius:"18px", border:"1px solid gray"}}
                        /> */}
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-primary"
                style={{
                  background: "#7BD755",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  padding: "10px 28px",
                  opacity: disableSubmit ? 0.6 : 1,
                  cursor: disableSubmit ? "not-allowed" : "pointer",
                }}
                disabled={disableSubmit}
                onClick={() => {
                  handleSubmit(formData);
                }}
              >
                Submit
              </button>
              <button
                className="btn btn-primary"
                style={{
                  background: "white",
                  color: "#7BD755",
                  border: "1px solid #7BD755",
                  borderRadius: "20px",
                  padding: " 10px 28px",
                }}
                onClick={closeAcceptModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ padding: "24px" }} className=" mt-4">
        <div className="d-flex justify-content-between">
          <h1 style={{ fontWeight: "600", paddingBottom: "10px" }}>
            Order Details
          </h1>
          {/* {!poDetails?.is_accepted_item==1 &&  <button
          className="submit-btn"
         onClick={() => setShowRejectModal(true)}
        >
          Reject Order
        </button>} */}

          {poDetails?.status === "Pending" && (
            <button className="submit-btn">Pending</button>
          )}
        </div>

        <div
          style={{ borderBottom: "1px solid lightgray" }}
          className="d-flex flex-wrap p-3 mb-4 gap-5"
        >
          {/* {Object.entries(poDetails)
          .filter(([key]) => includedFields.includes(key)) 
          .map(([key, value], index) => (
            <div className="d-flex flex-column me-4 mb-3" key={index}>
              <h6 className="text-muted">
                {fieldLabels[key] || key.replace(/([A-Z])/g, " $1")}{" "}
           
              </h6>
              <span>{value ?? "--"}</span>
            </div>
          ))} */}

          {Object.entries(poDetails)
            .filter(([key]) => includedFields.includes(key)) // Filter out excluded fields
            .filter(
              ([key, value]) =>
                !(
                  key === "payment_trans_image" &&
                  !poDetails?.payment_trans_image
                ),
            ) // Exclude payment_trans_image if it's null
            .map(([key, value], index) => {
              // Handle approval_remark condition
              if (
                key === "approval_remark" &&
                (!value || value.trim() === "")
              ) {
                value = poDetails.remark;
              }

              // Concatenate dealer_address, city_name, and state_name for Address
              if (key === "dealer_address") {
                value = `${poDetails.dealer_address || ""} ${
                  poDetails.city_name || ""
                }, ${poDetails.state_name || ""}`.replace(/,\s*$/, "");
              }

              // Set default value for Payment Status
              // if (key === "payment_status" && (!value || value.trim() === "")) {
              //   value = "Pending";
              // }

              // if (
              //   key === "payment_status_remark" &&
              //   (value === null ||
              //     value === undefined ||
              //     value.trim() === "" ||
              //     value === "null")
              // ) {
              //   value = "--";
              // }

              return (
                <div
                  className="col-3 col-sm-3 col-lg-3 col-xl-3 d-flex flex-column me-4 mb-3 details-section-manageorder"
                  key={index}
                >
                  <h6 className="text-muted">
                    {fieldLabels[key] || key.replace(/([A-Z])/g, " $1")}
                  </h6>

                  {key === "payment_trans_image" && Array.isArray(value) ? (
                    <div
                      style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                      {value.map((imgSrc, imgIndex) => (
                        <img
                          key={imgIndex}
                          src={imgSrc}
                          alt={`Transaction Image ${imgIndex + 1}`}
                          onClick={() => setModalImage(imgSrc)} // Open modal with clicked image
                          style={{
                            maxWidth: "50px",
                            height: "50px",
                            borderRadius: "5px",
                            border: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                        />
                      ))}
                    </div>
                  ) : (
                    <span className="details-value">{value ?? "--"}</span>
                  )}
                </div>
              );
            })}

          <Modal
            show={!!modalImage}
            onHide={() => setModalImage(null)}
            centered
          >
            <Modal.Body className="text-center">
              <img
                src={modalImage}
                alt="Zoomed Transaction Image"
                style={{ width: "100%", height: "auto", borderRadius: "10px" }}
              />
            </Modal.Body>
          </Modal>
        </div>
        <div>
          {vehicleData.length > 0 && (
            <>
              <h6
                className="mt-4"
                style={{ fontWeight: "600", fontSize: "18px" }}
              >
                Vehicle Details
              </h6>
              {renderTable(
                vehicleData,
                setVehicleData,
                "Vehicle",
                poDetails.postatus,
              )}
            </>
          )}
          {accessoryData.length > 0 && (
            <>
              <h6
                className="mt-4"
                style={{ fontWeight: "600", fontSize: "18px" }}
              >
                Accessory Details
              </h6>
              {renderTable(
                accessoryData,
                setAccessoryData,
                "Accessories",
                poDetails.postatus,
              )}
            </>
          )}
          {sparePartData.length > 0 && (
            <>
              <h6
                className="mt-4"
                style={{ fontWeight: "600", fontSize: "18px" }}
              >
                Battery Details
              </h6>
              {renderTable(
                sparePartData,
                setSparePartData,
                "Spare-Parts",
                poDetails.postatus,
              )}
            </>
          )}
        </div>

        {/*   <div>
          <h6 className="mt-5" style={{ fontWeight: "600", fontSize: "18px" }}>
            Payment Details
          </h6>
          <CustomTable
            data={tablepaymentStatus}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            itemsPerPage={10}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            isADDcomplainTable={true}
          />
        </div> */}

        {showModal && (
          <Modal show={showModal} onHide={handleModalClose} centered>
            <h6 className="mb-3">Damaged Item Details</h6>
            <input
              type="number"
              value={damagedQty}
              onChange={handleDamageChange}
              className="form-control"
              placeholder="Enter Damaged Quantity"
            />
            {DamagedInputs()}
          </Modal>
        )}

        {/* View Serial Modal */}
        {/* {showSerialModal && (
    <Modal show={showSerialModal} onHide={() => setShowSerialModal(false)} centered>
        <Modal.Header closeButton>
          <div>
            <h6>Serial Details</h6>
          </div>
        </Modal.Header>
        <Modal.Body>
            {loadingSerialData ? (
                <div className="text-center">Loading...</div>
            ) : actionTaken.length > 0 ? (
              <div>
     
     
              <div className='tableWrapper'>
                <div className='admin-list-container'>
                <div className='listsearchContainer'>
                  <h5>Serial List</h5>
                  
                  </div>
                
                </div>
        
                <CustomTable
                 data={actionTaken} headers={TABLE_HEADERS} keyMapping={keyMapping}   itemsPerPage={10}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  // handleViewButton={handleEditButton} 
                  totalRecords={totalRecords} 
                  />
              </div>
            </div>
            ) : (
                <p className="text-center">No serial details available</p>
            )}
        </Modal.Body>
    </Modal>
)} */}

        {showSerialModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}>Order Details</h6>
                <button
                  className="close-button"
                  onClick={() => setShowSerialModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                {loadingSerialData ? (
                  <div className="text-center">Loading...</div>
                ) : actionTaken.length > 0 ? (
                  <div>
                    <div className="tableWrapper">
                      {/* <div className='admin-list-container'> */}
                      {/* <div className='listsearchContainer'>
                        <h5>Serial List</h5> 
                      </div> */}
                      {/* </div> */}
                      <CustomTable
                        data={actionTaken}
                        headers={TABLE_HEADERS}
                        keyMapping={keyMapping}
                        itemsPerPage={30}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        totalRecords={totalRecords}
                        // isADDcomplainTable={true}
                      />
                    </div>
                  </div>
                ) : (
                  <p className="text-center">No serial details available</p>
                )}
              </div>
            </div>
          </div>
        )}

        {showRejectModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h5>Reject Remark</h5>
              <textarea
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Add your remark here"
                rows="4"
                className="remark-textarea"
              />
              <div className="modal-buttons">
                <button
                  onClick={() => handleApprovalAPI(remark)}
                  className="submit-button"
                >
                  Submit
                </button>
                <button
                  onClick={handleRejectModalClose}
                  className="cancel-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderDetails;
